module.exports = __webpack_public_path__ + "static/media/rightbs.98fe3d43.png";